import Vue from "vue";
import Vuex from "vuex";
import { Network } from "./modules/net-finder/network";
import { ManagedNode } from "./modules/net-finder/managedNode";
import { Snapshot } from "./modules/net-finder/snapshot";
import { Task } from "./modules/net-finder/task";
import { VSensor } from "./modules/net-finder/vSensor";

Vue.use(Vuex);

export interface IRootState {
  netFinder: {
    network: Network;
    managedNode: ManagedNode;
    snapshot: Snapshot;
    task: Task;
    vSensor: VSensor;
  };
}

export default new Vuex.Store<IRootState>({});
